import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { I18nProvider } from "@/i18n/I18nProvider";
import { CartProvider } from "@/contexts/CartContext";
import LandingPage from "@/pages/LandingPage";
import ProductDetail from "@/pages/ProductDetail";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import AGB from "@/pages/AGB";
import AdminSocial from "@/pages/AdminSocial";
import CookieConsent from "@/components/CookieConsent";
import CartDrawer from "@/components/CartDrawer";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <I18nProvider>
          <CartProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/product/:handle" element={<ProductDetail />} />
                <Route path="/impressum" element={<Impressum />} />
                <Route path="/datenschutz" element={<Datenschutz />} />
                <Route path="/agb" element={<AGB />} />
                <Route path="/admin/social" element={<AdminSocial />} />
              </Routes>
              <CartDrawer />
              <CookieConsent />
            </BrowserRouter>
            <Toaster
              position="bottom-right"
              theme="dark"
              toastOptions={{
                style: {
                  background: "#0f0f0f",
                  color: "#fff",
                  border: "1px solid #262626",
                  borderRadius: 0,
                  fontFamily: "Outfit, sans-serif",
                },
              }}
            />
          </CartProvider>
        </I18nProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
